import BusinessAccountQuery from './BusinessAccountQuery';

export default BusinessAccountQuery;
